<template>
    <div class="X_cerrar" @click="cerrar">&ltrif;</div>
</template>

<script>
export default {
  methods: {
    cerrar () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.X_cerrar{
  font-family: OpenL;
  font-size: 35px;
  position: absolute;
  right: 14px;
  color:white;
  top: 9px;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(1, 117, 163, 0);
  transition: all 0.5s ease-out;
}
.X_cerrar:hover{
  border: solid 1px rgba(10, 90, 140, 0.8);
  transform: translateX(-6px);
}
</style>
